// extracted by mini-css-extract-plugin
module.exports = {"userCard__name":"userCard__name-30Sm_","userCard__companion":"userCard__companion-WzTWB","userCard__empty":"userCard__empty-lhCoj","userCard__avatar":"userCard__avatar-afl2U"};